import Gtm from '@grebban/gtm';

export default ({ userId, customerNumber }: {
    userId: string;
    customerNumber: string;
}) => {
    Gtm.addDataLayerEvent('account_created', {
        event_action: 'Account Created',
        event_category: 'customer_homepage',
        event_label: customerNumber,
        user_id: userId
    });
}